/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLeftSquare = createReactComponent("outline", "arrow-left-square", "IconArrowLeftSquare", [["path", { "d": "M17 12h-14", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M21 14h-4v-4h4z", "key": "svg-2" }]]);

export { IconArrowLeftSquare as default };
//# sourceMappingURL=IconArrowLeftSquare.mjs.map
